export const FIELD_NECESSITY_MODEL = "field-necessity";

const fieldNecessityModel = {
  field: "",
  form: "",
  required: false
};

export default fieldNecessityModel;
